
/* Patricia Viera - home interactions (home-only, fully guarded) */
(function () {
  function ready(fn){ if(document.readyState!='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function () {
    var main = document.getElementById('MainContent');
    if (!main) return;

    // Reveal on scroll (adds .visible). Failsafe: reveal everything after 1.5s and if no IO.
    var items = main.querySelectorAll('.reveal-on-scroll');
    function revealAll(){ items.forEach(function(el){ el.classList.add('visible'); }); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries, obs){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('visible'); obs.unobserve(e.target);} });
      }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
      items.forEach(function(el){ io.observe(el); });
      setTimeout(revealAll, 1500); // failsafe: nothing stays hidden
    } else {
      revealAll();
    }

    // Hero fade-in elements
    main.querySelectorAll('#hero .fade-in-up').forEach(function(el){ el.classList.add('visible'); });

    // Traveling logo shrink on scroll (guarded)
    var logo = document.getElementById('traveling-logo');
    var heroText = document.getElementById('hero-text');
    if (logo) {
      var startW = 320, endW = 130, endScroll = 400;
      window.addEventListener('scroll', function(){
        var y = window.scrollY || 0;
        if (y <= endScroll) {
          var p = y / endScroll;
          logo.style.width = (startW - (startW - endW) * p) + 'px';
          logo.style.opacity = '1';
        } else { logo.style.opacity = '0'; }
        if (heroText) heroText.style.transform = 'translateY(-' + (y * 0.4) + 'px)';
      }, { passive: true });
    }

    // Hero image rotator: cross-fade entre 2 imagens no desktop (guarded).
    var heroRotator = main.querySelector('#hero .hero-rotator');
    if (heroRotator) {
      var slides = heroRotator.querySelectorAll('.hero-rotator__slide');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (slides.length > 1 && !reduceMotion) {
        var ms = parseInt(heroRotator.getAttribute('data-rotate-ms'), 10) || 6000;
        var slideIdx = 0;
        setInterval(function(){
          slides[slideIdx].classList.remove('is-active');
          slideIdx = (slideIdx + 1) % slides.length;
          slides[slideIdx].classList.add('is-active');
        }, ms);
      }
    }

    // Private access button -> contact (no modal on this base theme)
    var pbtn = document.getElementById('open-private-btn');
    if (pbtn) pbtn.addEventListener('click', function(){ window.location.href = '/pages/contact'; });
  });
})();
